import { useEffect, useState } from "react";

import "./styles.css";

import {
    ClienteInterface,
    IClienteFilter,
} from "../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import { ListarClientesController } from "../../../Controllers/Geral/GestaoClientes/GestaoClientesController";

import { useHistory, useLocation } from "react-router-dom";
import StickyToolbar from "../../../Components/StickyToolbar";
import {
    ListarEmpreendimentosComObraController,
    ListarEmpreendimentosController,
} from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import {
    IEmpreendimento,
    IUnidade,
} from "../../../Interfaces/Geral/Produtos/ProdutosInterface";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
// import ComunicadoCliente from "./ComunicadoCliente";
import TabelaCliente from "./TabelaCliente";
import FilterClienteRow from "./FilterClientesRow";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import { ACESSOS } from "../../../Routes/Acessos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useUserInfor } from "../../../Context/User";
// import ComunicadoClienteImportarPlanilha from "./ComunicadoCliente/ComunicadoClienteContext/ComunicadoClienteContext";

const filtroInicial = {
    DS_EMAIL: "",
    DS_NOME: "",
    NR_CPF: "",
    NR_TELEFONE: "",
    ID_EMPREENDIMENTO: undefined,
    ID_UNIDADE: 0,
    ID_CASO: 0,
};

export default function GestaoClientes() {
    const location = useLocation();

    const { FUNCOES } = useUserInfor().UserInfor;

    const history = useHistory();

    const modulo_url = location.pathname.split("/")[1];
    const FILTRO_GESTAO_CLIENTES = sessionStorage.getItem(
        "FILTRO_GESTAO_CLIENTES"
    );
    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );

    const { id } = useModuloInfo();

    const [lstClientes, setLstClientes] = useState<Array<ClienteInterface>>();
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [lstEmpreendimentos, SetLstEmpreendimentos] = useState(
        [] as Array<IEmpreendimento>
    );
    const [lstUnidades, setLstUnidades] = useState([] as Array<IUnidade>);
    const [filter, setFilter] = useState<IClienteFilter>(
        FILTRO_GESTAO_CLIENTES
            ? JSON.parse(FILTRO_GESTAO_CLIENTES)
            : filtroInicial
    );

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    useEffect(() => {
        (modulo_url === "Cobranca"
            ? ListarEmpreendimentosComObraController()
            : ListarEmpreendimentosController()
        ).then((res) => {
            SetLstEmpreendimentos(res);
        });
        if (FILTRO_GESTAO_CLIENTES) {
            updateClientes(1, filter);
        }

        // eslint-disable-next-line
    }, []);

    function updateClientes(page: number, filter: IClienteFilter) {
        setLoading(true);
        ListarClientesController(page, id ?? 0, {
            ...filter,
            ID_EMPREENDIMENTO: idEmpreendimento,
        })
            .then((response) => {
                setLstClientes(response.LISTA_CLIENTES);
                setTotalPaginas(response.NR_TOTAL_PAGINAS);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                <div className="d-flex align-items-center justify-content-between col-12">
                    <h4 className="text-dark font-weight-bold my-1 mr-5">
                        Gestão de Clientes
                    </h4>
                    <div>
                        {/* {mostrarNavDeTela(
                            ACESSOS.GERAL.TELAS.GESTAO_ATENDIMENTOS.ID_TELA,
                            UserInfor.TELAS
                        ) && (
                            <button
                                className="btn btn-outline-primary"
                                onClick={() => {
                                    history.push(
                                        ACESSOS.GERAL.TELAS.GESTAO_ATENDIMENTOS
                                            .DS_PATH
                                    );
                                }}
                            >
                                Relatório Geral
                            </button>
                        )} */}
                        {/* <button
                            className="btn btn-outline-primary ml-3"
                            onClick={() => {
                                setModal({
                                    Component: () => (
                                        <ComunicadoClienteImportarPlanilha>
                                            <ComunicadoCliente
                                                setShow={setShow}
                                            />
                                        </ComunicadoClienteImportarPlanilha>
                                    ),
                                    headerComponent: "Comunicado em Lote",
                                    IconHeader: faComment,
                                    size: "xl",
                                    scrollable: true,
                                });
                                setShow(true);
                            }}
                        >
                            Gerar Comunicado
                        </button> */}
                        {!FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_BLOQUEAR_EDICAO_CONTAS"
                        ) &&
                            ACESSOS.VENDAS.ID_MODULO !== id && (
                                <button
                                    className="btn btn-outline-success ml-3"
                                    onClick={() => {
                                        history.push(
                                            ACESSOS.GERAL.TELAS
                                                .CADASTRAR_CLIENTE.DS_PATH
                                        );
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPlus} /> Cadastrar
                                    Cliente
                                </button>
                            )}
                    </div>
                </div>
            </div>
            <div className="cardsTable mt-3">
                <TabelaCliente
                    totalPaginas={totalPaginas}
                    filter={{
                        ...filter,
                        ID_EMPREENDIMENTO: idEmpreendimento,
                        DS_EMAIL: filter.DS_EMAIL,
                        DS_NOME: filter.DS_NOME,
                        ID_UNIDADE: filter.ID_UNIDADE,
                        ID_VENDA: filter.ID_VENDA,
                        NR_CPF: filter.NR_CPF,
                        NR_TELEFONE: filter.NR_TELEFONE,
                    }}
                    setTotalPaginas={setTotalPaginas}
                    setLstClientes={setLstClientes}
                    setLoading={setLoading}
                    loading={loading}
                    lstClientes={lstClientes}
                    setModal={setModal}
                    setShow={setShow}
                />
            </div>

            <StickyToolbar
                Filters={
                    <FilterClienteRow
                        setTotalPaginas={setTotalPaginas}
                        idEmpreendimento={idEmpreendimento}
                        setLstUnidades={setLstUnidades}
                        lstEmpreendimentos={lstEmpreendimentos}
                        lstUnidades={lstUnidades}
                        setFilter={setFilter}
                        loading={loading}
                        setLstClientes={setLstClientes}
                        setLoading={setLoading}
                        updateClientes={updateClientes}
                        filter={{
                            ...filter,
                            ID_EMPREENDIMENTO: idEmpreendimento,
                            DS_EMAIL: filter.DS_EMAIL,
                            DS_NOME: filter.DS_NOME,
                            ID_UNIDADE: filter.ID_UNIDADE,
                            ID_VENDA: filter.ID_VENDA,
                            NR_CPF: filter.NR_CPF,
                            NR_TELEFONE: filter.NR_TELEFONE,
                        }}
                        setIdEmpreendimento={setIdEmpreendimento}
                    />
                }
                active={!!FILTRO_GESTAO_CLIENTES}
                inicialyOpenned
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
